export default "__VITE_ASSET__086c6081__"